export default "__VITE_ASSET__bzpzkhGK__"